import apiService from './apiService';
import { getApiBaseUrl } from '../config/apiConfig';

const PREFIX = '/klub/magazine';

async function request(promise) {
  const res = await promise;
  if (!res.success) {
    throw new Error(res.message || 'Erreur API');
  }
  return res.data !== undefined ? res.data : res;
}

async function downloadZip(path, filename = 'export.zip') {
  const base = getApiBaseUrl().replace(/\/+$/, '');
  const url = `${base}${PREFIX}${path}`;
  const token = localStorage.getItem('auth_token') || localStorage.getItem('jwt_token');
  const headers = { Accept: 'application/zip, application/json' };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(url, { method: 'POST', headers });
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.message || `Erreur HTTP ${response.status}`);
  }

  const blob = await response.blob();
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(link.href);
}

const klubMagazineService = {
  listParutions() {
    return request(apiService.get(`${PREFIX}/parutions`));
  },

  getParution(month) {
    return request(apiService.get(`${PREFIX}/parutions/${month}`));
  },

  candidates(month) {
    const qs = month ? `?month=${encodeURIComponent(month)}` : '';
    return request(apiService.get(`${PREFIX}/commercants/candidates${qs}`));
  },

  offreCandidates(month) {
    const qs = month ? `?month=${encodeURIComponent(month)}` : '';
    return request(apiService.get(`${PREFIX}/offres/candidates${qs}`));
  },

  propose(month, replace = true, counts = {}) {
    return request(apiService.post(`${PREFIX}/parutions/${month}/propose`, {
      replace,
      scope: counts.scope || 'all',
      commercants_count: counts.commercants_count,
      offres_count: counts.offres_count,
    }));
  },
  replaceCommercants(month, commercants) {
    return request(apiService.put(`${PREFIX}/parutions/${month}/commercants`, { commercants }));
  },

  replaceOffres(month, offres) {
    return request(apiService.put(`${PREFIX}/parutions/${month}/offres`, { offres }));
  },

  patchCommercant(month, id, payload) {
    return request(apiService.patch(`${PREFIX}/parutions/${month}/commercants/${id}`, payload));
  },

  patchOffre(month, id, payload) {
    return request(apiService.patch(`${PREFIX}/parutions/${month}/offres/${id}`, payload));
  },

  refreshNouveau(month) {
    return request(apiService.post(`${PREFIX}/parutions/${month}/refresh-nouveau`));
  },

  exportCommercants(month) {
    return downloadZip(`/parutions/${month}/export/commercants`, `commercants-${month}.zip`);
  },

  exportOffres(month) {
    return downloadZip(`/parutions/${month}/export/offres`, `offres-${month}.zip`);
  },
};

export default klubMagazineService;
